/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import {
  BIKE_FACILITY_TYPE,
  BIKE_FACILITY_TYPE_VALUES,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT,
  SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES,
  STREET_BUFFER_WIDTH,
  STREET_BUFFER_WIDTH_VALUES,
  USABLE_BIKEWAY_WIDTH,
  USABLE_BIKEWAY_WIDTH_VALUES
} from '../constants/bike'
import { setBicycleInputs } from '../slices/criteriaSelection/bicycle'

export function setBikeSegmentInput() {
  const { bicycle, street, modalTiers } = store.getState()
  const { Bicycle: BTier } = modalTiers
  const { segments } = street
  const { bike_facility_type } = bicycle

  // If Bike Tier is 0 or NA , do not change inputs
  if (BTier === 0) {
    return
  }

  for (const key of Object.keys(bicycle)) {
    switch (key) {
      case BIKE_FACILITY_TYPE:
        // Check if there are any bike lanes
        if (
          segments.some((segment) => segment?.type === 'bike-lane') === true
        ) {
          // Check for number of bike lanes
          const bikeLanesArr = segments.filter(
            (segment) => segment?.type === 'bike-lane'
          )

          const bikeLaneWidth = bikeLanesArr.map((bikeLane) => bikeLane?.width)
          let minBikeLaneWidth = Math.min(...bikeLaneWidth)
          // if bike facility type is two way , then add the total width of the lanes
          if (
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4] ||
            bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]
          ) {
            minBikeLaneWidth = bikeLaneWidth.reduce((sum, val) => sum + val, 0)
          }

          // Set Usable bikelane  width
          if (minBikeLaneWidth < 4) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[7]
              })
            )
          } else if (minBikeLaneWidth >= 4 && minBikeLaneWidth < 5) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[6]
              })
            )
          } else if (minBikeLaneWidth >= 5 && minBikeLaneWidth < 6.5) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[5]
              })
            )
          } else if (minBikeLaneWidth >= 6.5 && minBikeLaneWidth < 8) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[4]
              })
            )
          } else if (minBikeLaneWidth >= 8 && minBikeLaneWidth < 10) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[3]
              })
            )
          } else if (minBikeLaneWidth >= 10 && minBikeLaneWidth < 11) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[2]
              })
            )
          } else if (minBikeLaneWidth >= 11 && minBikeLaneWidth < 14) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[1]
              })
            )
          } else if (minBikeLaneWidth >= 14) {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: USABLE_BIKEWAY_WIDTH_VALUES[0]
              })
            )
          } else {
            store.dispatch(
              setBicycleInputs({
                field: USABLE_BIKEWAY_WIDTH,
                value: ''
              })
            )
          }
          // Check for buffers
          const hasBuffer = bikeLanesArr.some((lane) => {
            const bikeLaneIndex = segments.findIndex(
              (segment) => segment?.id === lane?.id
            )

            return (
              ((segments[bikeLaneIndex + 1]?.type === 'divider' ||
                segments[bikeLaneIndex + 1]?.type === 'parking-lane') &&
                segments.some(
                  (segment, i) =>
                    segment?.type === 'drive-lane' && i > bikeLaneIndex
                )) ||
              ((segments[bikeLaneIndex - 1]?.type === 'divider' ||
                segments[bikeLaneIndex - 1]?.type === 'parking-lane') &&
                segments.some(
                  (segment, i) =>
                    segment?.type === 'drive-lane' && i < bikeLaneIndex
                ))
            )
          })

          const isBikeLaneNextToEachOther = bikeLanesArr.every((lane) => {
            const bikeLaneIndex = segments.findIndex(
              (segment) => segment?.id === lane?.id
            )

            return (
              (segments[bikeLaneIndex + 1] &&
                segments[bikeLaneIndex + 1].type.includes('bike-lane')) ||
              (segments[bikeLaneIndex - 1] &&
                segments[bikeLaneIndex - 1].type.includes('bike-lane'))
            )
          })
          segments.filter(
            (segment) =>
              segment?.type === 'divider' &&
              segment?.variantString?.includes('buffer')
          )
          // Get drive Lanes elevation
          const driveLaneElevation = segments.find(
            (segment) => segment?.type === 'drive-lane'
          )?.elevation
          // If there is only one bike lane
          const isRaised =
            driveLaneElevation !== undefined
              ? bikeLanesArr.every(
                  (lane) => lane?.elevation > driveLaneElevation
                )
              : false

          // Check if its Two way
          const isTwoWay = ['outbound', 'inbound'].every((direction) =>
            bikeLanesArr.some((lane) =>
              lane?.variantString?.includes(direction)
            )
          )

          // If bikelane has buffer, then check buffer width
          if (hasBuffer) {
            const firstDriveLaneIndex = segments?.findIndex((segment) =>
              ['drive-lane', 'bus-lane', 'brt-lane'].includes(segment?.type)
            )
            const firstBikeLaneIndex = segments?.findIndex(
              (segment) => segment?.type === 'bike-lane'
            )

            // Reverse segments to find last lane id
            const copyOfSegmentsToReverse = [...segments]

            const lastDriveLaneId = copyOfSegmentsToReverse
              .reverse()
              .find((segment) =>
                ['drive-lane', 'bus-lane', 'brt-lane'].includes(segment?.type)
              )?.id

            const lastDriveLaneIndex = segments.findIndex(
              (segment) => segment?.id === lastDriveLaneId
            )
            const lastBikeDriveLaneId = copyOfSegmentsToReverse.find(
              (segment) => segment?.type === 'bike-lane'
            )?.id
            const lastBikeLaneIndex = segments?.findIndex(
              (segment) => segment?.id === lastBikeDriveLaneId
            )

            let bufferLeftWidth = 0
            let bufferRightWidth = 0
            segments.forEach((segment, index) => {
              if (index > firstBikeLaneIndex && index < firstDriveLaneIndex) {
                bufferLeftWidth += segment?.width
              }
              if (index > lastDriveLaneIndex && index < lastBikeLaneIndex) {
                bufferRightWidth += segment?.width
              }
            })
            // if the bike facility type is Two way raised or two way roadway, then calculate buffer width for second bike lane
            if (
              bike_facility_type === BIKE_FACILITY_TYPE_VALUES[4] ||
              bike_facility_type === BIKE_FACILITY_TYPE_VALUES[5]
            ) {
              bufferLeftWidth = 0
              const secondBikeLaneIndex = firstBikeLaneIndex + 1
              segments.forEach((segment, index) => {
                if (
                  index > secondBikeLaneIndex &&
                  index < firstDriveLaneIndex
                ) {
                  bufferLeftWidth += segment?.width
                }
              })
            }

            // if (bufferLeftWidth > 6 || bufferRightWidth > 6) {
            //   store.dispatch(
            //     setBicycleInputs({
            //       field: STREET_BUFFER_WIDTH,
            //       value: STREET_BUFFER_WIDTH_VALUES[0]
            //     })
            //   )
            // } else if (
            //   (bufferLeftWidth >= 3 && bufferLeftWidth <= 6) ||
            //   (bufferRightWidth >= 3 && bufferRightWidth <= 6)
            // ) {
            //   store.dispatch(
            //     setBicycleInputs({
            //       field: STREET_BUFFER_WIDTH,
            //       value: STREET_BUFFER_WIDTH_VALUES[1]
            //     })
            //   )
            // } else if (bufferLeftWidth < 3 || bufferRightWidth < 3) {
            //   store.dispatch(
            //     setBicycleInputs({
            //       field: STREET_BUFFER_WIDTH,
            //       value: STREET_BUFFER_WIDTH_VALUES[2]
            //     })
            //   )
            // } else {
            //   store.dispatch(
            //     setBicycleInputs({
            //       field: STREET_BUFFER_WIDTH,
            //       value: ''
            //     })
            //   )
            // }
          }

          if (isRaised && isBikeLaneNextToEachOther) {
            store.dispatch(
              setBicycleInputs({
                field: key,
                value: BIKE_FACILITY_TYPE_VALUES[5]
              })
            )
          } else if (hasBuffer && isBikeLaneNextToEachOther) {
            store.dispatch(
              setBicycleInputs({
                field: key,
                value: BIKE_FACILITY_TYPE_VALUES[4]
              })
            )
          } else if (isRaised) {
            store.dispatch(
              setBicycleInputs({
                field: key,
                value: BIKE_FACILITY_TYPE_VALUES[3]
              })
            )
          } else if (hasBuffer && !isBikeLaneNextToEachOther) {
            store.dispatch(
              setBicycleInputs({
                field: key,
                value: BIKE_FACILITY_TYPE_VALUES[2]
              })
            )
          } else if (!hasBuffer && !isBikeLaneNextToEachOther) {
            store.dispatch(
              setBicycleInputs({
                field: key,
                value: BIKE_FACILITY_TYPE_VALUES[1]
              })
            )
          } else {
            store.dispatch(
              setBicycleInputs({
                field: key,
                value: ''
              })
            )
          }
        } else {
          // If there are no bike lanes
          store.dispatch(
            setBicycleInputs({
              field: key,
              value: BIKE_FACILITY_TYPE_VALUES[0]
            })
          )
        }
        break

      case SHARED_LANE_PAVEMENT_MARKINGS_PRESENT:
        // Check if there are shared bike lanes

        if (
          segments.some(
            (segment) =>
              (segment?.type === 'drive-lane' ||
                segment?.type === 'bus-lane' ||
                segment?.type === 'brt-lane') &&
              segment?.variantString?.includes('sharrow') &&
              !segment?.variantString?.includes('copy')
          ) === true ||
          segments.some(
            (segment) =>
              (segment?.type === 'drive-lane' ||
                segment?.type === 'bus-lane' ||
                segment?.type === 'brt-lane') &&
              segment?.variantString?.includes('shared') &&
              !segment?.variantString?.includes('copy')
          ) === true
        ) {
          store.dispatch(
            setBicycleInputs({
              field: key,
              value: SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[1]
            })
          )
        } else if (
          segments.some(
            (segment) =>
              (segment?.type === 'drive-lane' ||
                segment?.type === 'bus-lane' ||
                segment?.type === 'brt-lane') &&
              segment?.variantString?.includes('sharrow') &&
              segment?.variantString?.includes('copy')
          ) === true ||
          segments.some(
            (segment) =>
              (segment?.type === 'drive-lane' ||
                segment?.type === 'bus-lane' ||
                segment?.type === 'brt-lane') &&
              segment?.variantString?.includes('shared') &&
              segment?.variantString?.includes('copy')
          ) === true
        ) {
          store.dispatch(
            setBicycleInputs({
              field: key,
              value: SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[0]
            })
          )
        } else {
          // No shared bike lanes
          store.dispatch(
            setBicycleInputs({
              field: key,
              value: SHARED_LANE_PAVEMENT_MARKINGS_PRESENT_VALUES[2]
            })
          )
        }
        break

        break
      default:
    }
  }
}
